(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/auth.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/auth.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  showLoaderAtom,
  showFallbackAtom,
  showFallbackQrAtom
} = svs.iam_login.atoms;
const {
  Mobile,
  Desktop
} = svs.iam_login.components.media_queries;
const {
  Footer
} = svs.iam_login.components.footer;
const Auth = () => {
  const isMobile = svs.core.detect.formfactor.mobile();
  const showLoader = useAtomValue(showLoaderAtom);
  const showFallback = useAtomValue(showFallbackAtom);
  const showFallbackQr = useAtomValue(showFallbackQrAtom);
  const shouldShowFooter = isMobile ? !showLoader && !showFallback && !showFallbackQr : !showLoader;
  return React.createElement("section", null, React.createElement("div", {
    className: "login-section"
  }, isMobile ? React.createElement(Mobile, null) : React.createElement(Desktop, null), shouldShowFooter && React.createElement(Footer, null)));
};
svs.iam_login.Auth = Auth;

 })(window);